import React from "react";
import styled from "styled-components";

import { useQueryGetObjectivePath } from "@examspark/common-app";
import { Text, Toolbar, VSpace } from "@examspark/common-ui";
import {
  getObjectiveCategory,
  getObjectiveCurriculumUsage,
  ObjectiveCategoryBadge,
  ObjectiveCurriculumUsageBadge,
} from "@examspark/customer/tcmpc";
import { ParsedUnitObjective, Unit } from "@examspark/types";

import Breadcrumbs from "./common/Breadcrumbs";
import ObjectiveSpecificity from "./common/ObjectiveSpecificity";
import UnitContent from "./common/UnitContent";

const StyledStatementContent = styled(UnitContent)`
  font-size: 1.3rem;
`;

const StyledToolbar = styled(Toolbar)`
  margin-top: 1rem;
  padding: 1rem 0.25rem;
  /* border-radius: 0.5rem; */
  border-top: solid 1px #ddd;
  border-bottom: solid 1px #ddd;
`;

type Props = {
  objective: ParsedUnitObjective | null | undefined;
  unit?: Unit | null;
};

const ObjectiveDetail = ({ objective, unit }: Props) => {
  const { standardQuery, publicationQuery, documentQuery, sectionQuery } =
    useQueryGetObjectivePath(objective?.id);

  const category = getObjectiveCategory(objective);
  const usage = getObjectiveCurriculumUsage(objective?.objectivesItem);

  return (
    <VSpace size="3rem">
      <VSpace size="1rem">
        <Text.H2>
          <Breadcrumbs
            items={[
              <span key="pub">{publicationQuery.data?.content}</span>,
              <span key="doc">{documentQuery.data?.content}</span>,
              <span key="sec">{sectionQuery.data?.content}</span>,
              <span key="obj">{standardQuery.data?.abbreviation}</span>,
            ]}
          />
        </Text.H2>
        {(!!category || !!usage || !!unit?.name) && (
          <StyledToolbar>
            <ObjectiveCategoryBadge
              value={getObjectiveCategory(objective)}
              showLabel
            />
            <ObjectiveCurriculumUsageBadge
              value={getObjectiveCurriculumUsage(objective?.objectivesItem)}
              showLabel
            />
            <Toolbar.Right>
              <Text.Body>{unit?.name}</Text.Body>
            </Toolbar.Right>
          </StyledToolbar>
        )}
      </VSpace>
      <VSpace size="0.5rem">
        <Text.H2>Standard Text</Text.H2>
        <StyledStatementContent
          content={
            objective?.objectivesItem?.data?.content ?? objective?.content
          }
        />
      </VSpace>
      <ObjectiveSpecificity
        objective={objective}
        header={<Text.H2>Specificity</Text.H2>}
      />
    </VSpace>
  );
};

export default ObjectiveDetail;
